export default {autoTrackPageView: false};
